/**
 * J-code level status for auth letter review flow.
 * - NewLetterUploaded: incorrect letter was replaced; new letter uploaded (yellow icon).
 * - ReviewedAndSaved: user reviewed on authorisation details and clicked Save (light green icon + bg).
 */
export enum AuthLetterReviewStatus {
  NewLetterUploaded = "new_letter_uploaded",
  ReviewedAndSaved = "reviewed_and_saved",
}
